<div class="flex min-w-0 flex-1 flex-col">
  <!-- Slot for things like breadcrumbs -->
  <ng-content select="[before-table]"></ng-content>

  <div class="flex-1">
    <aura-data-table
      matSort
      [inputColumns]="columns()"
      [filters]="filters()"
      [items]="items()"
      [count]="count()"
      [loading]="isLoading()"
      [pagination]="pagination()"
      [topButtons]="topButtons()"
      [itemActions]="itemActions()"
      [mappedFilters]="mappedFilters()"
      [hideSearch]="false"
      (removeFilter)="removeFilter()?.($event)"
      (clearFiltering)="clearFiltering()?.()"
      (triggerFiltering)="triggerFiltering()?.()"
      (triggerRefresh)="triggerRefresh()?.()"
      (filterViewChanged)="filterViewChanged()?.($event)"
      (itemClicked)="itemClicked()?.($event)"
      (pageChanged)="pageChanged()?.($event)"
      (searchChanged)="searchChanged()?.($event)"
      (matSortChange)="sortChanged()?.($event)"
    >
      <ng-template #filterTemplate>
        <core-tickets-data-table-filter
          [dto]="appliedFilter()"
          [filters]="filters()"
          [currentFilterView]="currentFilterView()"
          (filterChanged)="filterChanged()?.($event)"
        />
      </ng-template>

      <!-- Dynamic column rendering -->
      @for (column of columns(); track $index) {
        @if (!column.native) {
          <ng-container [matColumnDef]="column.key">
            <th
              mat-header-cell
              *matHeaderCellDef
              mat-sort-header
              [sortActionDescription]="'Trier par ' + column.label | lowercase"
              class="font-bold text-primary"
            >
              {{ column.label }}
            </th>

            @switch (column.key) {
              @case ('zammadTicketId') {
                <td mat-cell *matCellDef="let ticket">#{{ ticket.zammadTicketId }}</td>
              }
              @case ('subject') {
                <td mat-cell *matCellDef="let ticket">
                  <div class="font-semibold">{{ ticket.subject }}</div>
                </td>
              }
              @case ('tags') {
                <td mat-cell *matCellDef="let ticket">
                  @if (ticket.tags && ticket.tags.length > 0) {
                    <div class="flex flex-wrap gap-1">
                      @for (tag of ticket.tags; track tag) {
                        <aura-simple-chip [text]="tag" class="scale-90 origin-left" />
                      }
                    </div>
                  } @else {
                    <span class="text-gray-9">-</span>
                  }
                </td>
              }
              @case ('priority') {
                <td mat-cell *matCellDef="let ticket">
                  @if (ticket.priority) {
                    <span
                      [class]="
                        'text-xs font-semibold px-2.5 py-0.5 rounded-full uppercase tracking-wider border ' +
                        (ticket.priority === 'high'
                          ? 'bg-red-3 text-red-11 border-red-6'
                          : ticket.priority === 'low'
                            ? 'bg-sky-3 text-sky-11 border-sky-6'
                            : 'bg-gray-3 text-gray-11 border-gray-6')
                      "
                    >
                      {{
                        ticket.priority === 'high' ? 'haute' : ticket.priority === 'low' ? 'basse' : 'normale'
                      }}
                    </span>
                  } @else {
                    <span class="text-gray-9">-</span>
                  }
                </td>
              }
              @case ('status') {
                <td mat-cell *matCellDef="let ticket">
                  <aura-simple-chip [text]="ticket.status" />
                </td>
              }
              @case ('createdAt') {
                <td mat-cell *matCellDef="let ticket">
                  {{ ticket.createdAt | luxonDate: 'humanize' }}
                </td>
              }
              @case ('updatedAt') {
                <td mat-cell *matCellDef="let ticket">
                  {{ ticket.updatedAt | luxonDate: 'humanize' }}
                </td>
              }
              @case ('user') {
                <td mat-cell *matCellDef="let ticket">
                  @if (ticket.user && ticket.user._id) {
                    <button
                      [matTooltip]="'Utilisateur'"
                      [routerLink]="['/users', ticket.user._id]"
                      mat-button
                      class="link flex flex-row items-center"
                    >
                      <aura-avatar
                        [label]="$safeNavigationMigration(ticket.user.identity?.firstName)"
                        [srcImage]="$safeNavigationMigration(ticket.user.identity?.avatar?.url)"
                        [size]="'xs'"
                      />

                      <div class="ml-2">
                        {{ $safeNavigationMigration(ticket.user.identity?.firstName) | titlecase }}
                        {{ $safeNavigationMigration(ticket.user.identity?.lastName) | titlecase }}
                      </div>
                    </button>
                  } @else if (ticket.zammadCustomer) {
                    <div class="flex flex-row items-center py-2 px-3 text-sm text-gray-12 font-medium">
                      {{ ticket.zammadCustomer.firstname | titlecase }}
                      {{ ticket.zammadCustomer.lastname | titlecase }}
                    </div>
                  }
                </td>
              }
              @default {
                <td mat-cell *matCellDef="let ticket">
                  {{ ticket[column.key] }}
                </td>
              }
            }
          </ng-container>
        }
      }
    </aura-data-table>
  </div>
</div>
